import { render } from "./SpecialismEditModal.vue?vue&type=template&id=f1c96b48&ts=true"
import script from "./SpecialismEditModal.vue?vue&type=script&lang=ts"
export * from "./SpecialismEditModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__